<template>
  <section>
    <div
      class="container-fluid border-bottom"
      v-for="(groove, index) in possibleItems.list"
      v-bind:key="index"
    >
      <div class="row">
        <div
          class="col-10 text-start"
          @click="toggleGrooveForm(index)"
          style="cursor: pointer"
        >
          <h5>{{ $t("Menu.list.grooves.groove") }} {{ index + 1 }}</h5>
          <p v-if="possibleItems.grooves && currentGrooveId != index">
            {{ possibleItems.grooves.types[groove.type].text }} |
            {{ $n(groove.width) }} {{ $t("Menu.list.grooves.mm") }} |
            <span class="text-nowrap">
              <span
                v-if="possibleItems.grooves.arrangements[groove.arrangement]"
              >
                {{
                  possibleItems.grooves.arrangements[groove.arrangement].text
                }}
                {{ $t("Menu.list.grooves.form.onObject") }}
              </span>
              <span v-if="possibleItems.grooves.objects[groove.object]">
                {{ possibleItems.grooves.objects[groove.object].text }}
              </span>
            </span>
          </p>
        </div>
        <div class="col-2 text-end">
          <img
            :src="appUrl + '/img/icons/edit.svg'"
            class="icon open"
            @click="toggleGrooveForm(index)"
            v-if="currentGrooveId != index"
          />
          <img
            :src="appUrl + '/img/icons/close.svg'"
            class="icon"
            @click="toggleGrooveForm(index)"
            v-else
          />
        </div>
      </div>
      <template v-if="currentGrooveId == index">
        <div class="row">
          <div class="col-4">
            <br />
            <img
              @error="
                $parent.setIconNotAvailable(
                  $refs['current_' + currentGroove.type]
                )
              "
              :ref="'current_' + currentGroove.type"
              :src="
                appUrl + '/img/assets/grooves/' + currentGroove.type + '.jpg'
              "
              class="thumb"
              :srcset="
                appUrl + '/img/assets/grooves/' + currentGroove.type + '@2x.jpg'
              "
            />
          </div>
          <div class="col-8 form-horizontal">
            <br />
            <fieldset class="row form-group">
              <label class="col-3 control-label text-end">{{
                $t("Menu.list.grooves.form.type")
              }}</label>
              <div class="col-9" v-if="possibleItems.grooves">
                <select v-model="currentGroove.type" class="form-control">
                  <optgroup
                    :label="$t('Menu.list.grooves.form.grooves.standard')"
                  >
                    <template
                      v-for="(object, index) in possibleItems.grooves
                        .typesSorted"
                    >
                      <option
                        v-if="object.side_groove == 'no'"
                        v-bind:key="index"
                        :value="object.id"
                      >
                        {{ object.text }}
                      </option>
                    </template>
                  </optgroup>
                  <optgroup :label="$t('Menu.list.grooves.form.grooves.egde')">
                    <template
                      v-for="(object, index) in possibleItems.grooves
                        .typesSorted"
                    >
                      <option
                        v-if="object.side_groove == 'yes'"
                        v-bind:key="index"
                        :value="object.id"
                      >
                        {{ object.text }}
                      </option>
                    </template>
                  </optgroup>
                </select>
              </div>
            </fieldset>
            <fieldset class="row form-group">
              <label class="col-3 control-label text-end">{{
                $t("Menu.list.grooves.form.width")
              }}</label>
              <div class="col-9">
                <select v-model="currentGroove.width" class="form-control">
                  <template
                    v-for="(object, index) in possibleItems.grooves.widths[
                      currentGroove.type
                    ]"
                  >
                    <option
                      v-if="object.id"
                      v-bind:key="index"
                      :value="object.id.toFixed(1)"
                    >
                      {{ $n(object.text) }} mm
                    </option>
                  </template>
                </select>
              </div>
            </fieldset>
          </div>
        </div>
        <div class="row">
          <div class="col-8 form-horizontal offset-4">
            <fieldset class="row form-group">
              <label class="col-3 control-label text-end">{{
                $t("Menu.list.grooves.form.arrangement")
              }}</label>
              <div class="col-9">
                <select
                  v-model="currentGroove.arrangement"
                  class="form-control"
                >
                  <option
                    v-for="(object, index) in possibleItems.grooves
                      .arrangements"
                    v-bind:key="index"
                    :value="object.id"
                  >
                    {{ object.text }}
                  </option>
                </select>
              </div>
            </fieldset>
            <fieldset class="row form-group">
              <label class="col-3 control-label text-end">{{
                $t("Menu.list.grooves.form.onObject")
              }}</label>
              <div class="col-9">
                <select v-model="currentGroove.object" class="form-control">
                  <option
                    v-for="(object, index) in possibleItems.grooves.objects"
                    v-bind:key="index"
                    :value="object.id"
                  >
                    {{ object.text }}
                  </option>
                </select>
              </div>
            </fieldset>
            <fieldset
              class="row form-group"
              v-if="currentGroove.object.substr(0, 1) == 'D'"
            >
              <label class="col-3 control-label text-end">{{
                $t("Menu.list.grooves.form.colorGroove.title")
              }}</label>
              <div class="col-9">
                <select v-model="currentGroove.alignment" class="form-control">
                  <option value="no">
                    {{ $t("Menu.list.grooves.form.colorGroove.no") }}
                  </option>
                  <option value="yes">
                    {{ $t("Menu.list.grooves.form.colorGroove.yes") }}
                  </option>
                </select>
              </div>
            </fieldset>
          </div>
        </div>
        <div class="row">
          <div class="col-12 form-horizontal">
            <fieldset
              class="row form-group"
              v-if="
                possibleItems.grooves.widths[currentGroove.type] &&
                possibleItems.grooves.widths[currentGroove.type][
                  currentGroove.width
                ] &&
                possibleItems.grooves.widths[currentGroove.type][
                  currentGroove.width
                ].degree.length > 1
              "
            >
              <label class="col-6 control-label text-end">{{
                $t("Menu.list.grooves.form.degree.title")
              }}</label>
              <div class="col-6">
                <select v-model="currentGroove.degree" class="form-control">
                  <option
                    v-for="(object, index) in possibleItems.grooves.widths[
                      currentGroove.type
                    ][currentGroove.width].degree"
                    v-bind:key="index"
                    :value="object"
                  >
                    {{ object }}
                    {{ $t("Menu.list.grooves.form.degree.degree") }}
                  </option>
                </select>
              </div>
            </fieldset>
            <fieldset
              class="row form-group"
              v-if="currentGroove.alignment !== 'yes'"
            >
              <label class="col-6 control-label text-end"
                >{{ $t("Menu.list.grooves.form.posX") }} mm</label
              >
              <div class="col-6">
                <div class="input-group">
                  <input
                    type="number"
                    @keyup.enter="saveGroove"
                    value="0"
                    v-model="currentGroove.pos_x"
                    step="0.1"
                    min="-10"
                    max="10"
                    class="form-control"
                  />
                </div>
                <span class="exact-position-help">
                  {{ $t("Menu.list.grooves.form.posYHelp") }}
                </span>
              </div>
            </fieldset>
          </div>
        </div>
        <div class="row">
          <div class="col-6">
            <button class="btn btn-secondary btn-block" @click="dropGroove()">
              {{ $t("Menu.list.grooves.form.button.delete") }}
            </button>
          </div>
          <div class="col-6">
            <button class="btn btn-block btn-secondary" @click="saveGroove()">
              {{ $t("Menu.list.grooves.form.button.save") }}
            </button>
          </div>
        </div>
      </template>
    </div>
    <div
      class="container-fluid border-bottom"
      v-if="possibleItems.list.length == 0"
    >
      <div class="row">
        <div class="col-12 text-center">
          <br />
          {{ $t("Menu.list.grooves.empty") }}<br />
          <br />
        </div>
      </div>
    </div>
    <div class="container-fluid" v-if="currentGrooveId != 'add'">
      <div class="row">
        <div class="col-12 text-center">
          <button @click="toggleGrooveForm('add')" class="btn btn-secondary">
            {{ $t("Menu.list.grooves.add.button") }}
          </button>
        </div>
      </div>
    </div>
    <div class="container-fluid border-bottom" v-else>
      <div class="row">
        <div class="col-10 text-start">
          <h5>{{ $t("Menu.list.grooves.add.title") }}</h5>
          <br />
        </div>
        <div class="col-2 text-end">
          <img
            :src="appUrl + '/img/icons/close.svg'"
            class="icon"
            @click="toggleGrooveForm(null)"
          />
        </div>
      </div>
      <div class="row">
        <div class="col-4">
          <img
            @error="$parent.setIconNotAvailable([$refs['add_' + add.groove]])"
            :ref="'add_' + add.groove"
            :src="appUrl + '/img/assets/grooves/' + add.groove + '.jpg'"
            class="thumb"
            :srcset="appUrl + '/img/assets/grooves/' + add.groove + '@2x.jpg'"
          />
        </div>
        <div class="col-8 form-horizontal">
          <fieldset class="row form-group">
            <label class="col-3 control-label text-end">{{
              $t("Menu.list.grooves.form.type")
            }}</label>
            <div class="col-9" v-if="possibleItems.grooves">
              <select v-model="add.groove" class="form-control">
                <optgroup
                  :label="$t('Menu.list.grooves.form.grooves.standard')"
                >
                  <template
                    v-for="(object, index) in possibleItems.grooves.typesSorted"
                  >
                    <option
                      v-if="object.side_groove == 'no'"
                      v-bind:key="index"
                      :value="object.id"
                    >
                      {{ object.text }}
                    </option>
                  </template>
                </optgroup>
                <optgroup :label="$t('Menu.list.grooves.form.grooves.egde')">
                  <template
                    v-for="(object, index) in possibleItems.grooves.typesSorted"
                  >
                    <option
                      v-if="object.side_groove == 'yes'"
                      v-bind:key="index"
                      :value="object.id"
                    >
                      {{ object.text }}
                    </option>
                  </template>
                </optgroup>
              </select>
            </div>
          </fieldset>
          <fieldset
            class="row form-group"
            v-if="possibleItems.grooves && possibleItems.grooves.widths"
          >
            <label class="col-3 control-label text-end">{{
              $t("Menu.list.grooves.form.width")
            }}</label>
            <div class="col-9">
              <select v-model="add.width" class="form-control">
                <template
                  v-for="(object, index) in possibleItems.grooves.widths[
                    add.groove
                  ]"
                >
                  <option
                    v-if="object.id"
                    v-bind:key="index"
                    :value="object.id.toFixed(1)"
                  >
                    {{ $n(object.text) }} mm
                  </option>
                </template>
              </select>
            </div>
          </fieldset>
        </div>
      </div>
      <div class="row">
        <div class="col-4"></div>
        <div class="col-8 form-horizontal" v-if="possibleItems.grooves">
          <fieldset class="row form-group">
            <label class="col-3 control-label text-end">{{
              $t("Menu.list.grooves.form.arrangement")
            }}</label>
            <div class="col-9">
              <select v-model="add.arrangement" class="form-control">
                <option
                  v-for="(object, index) in possibleItems.grooves.arrangements"
                  v-bind:key="index"
                  :value="object.id"
                >
                  {{ object.text }}
                </option>
              </select>
            </div>
          </fieldset>
          <fieldset class="row form-group">
            <label class="col-3 control-label text-end">{{
              $t("Menu.list.grooves.form.onObject")
            }}</label>
            <div class="col-9">
              <select v-model="add.object" class="form-control">
                <option
                  v-for="(object, index) in possibleItems.grooves.objects"
                  v-bind:key="index"
                  :value="object.id"
                >
                  {{ object.text }}
                </option>
              </select>
            </div>
          </fieldset>
          <fieldset
            class="row form-group"
            v-if="add.object.substr(0, 1) == 'D'"
          >
            <label class="col-3 control-label text-end">{{
              $t("Menu.list.grooves.form.colorGroove.title")
            }}</label>
            <div class="col-9">
              <select v-model="add.alignment" class="form-control">
                <option value="no">
                  {{ $t("Menu.list.grooves.form.colorGroove.no") }}
                </option>
                <option value="yes">
                  {{ $t("Menu.list.grooves.form.colorGroove.yes") }}
                </option>
              </select>
            </div>
          </fieldset>
        </div>
      </div>
      <div class="row" v-if="possibleItems.grooves">
        <div class="col-12 form-horizontal">
          <fieldset
            class="row form-group"
            v-if="
              possibleItems.grooves.widths[add.groove] &&
              possibleItems.grooves.widths[add.groove][add.width] &&
              possibleItems.grooves.widths[add.groove][add.width].degree
                .length > 1
            "
          >
            <label class="col-6 control-label text-end">{{
              $t("Menu.list.grooves.form.degree.title")
            }}</label>
            <div class="col-6">
              <select v-model="add.degree" class="form-control">
                <option
                  v-for="(object, index) in possibleItems.grooves.widths[
                    add.groove
                  ][add.width].degree"
                  v-bind:key="index"
                  :value="object"
                >
                  {{ object }} {{ $t("Menu.list.grooves.form.degree.degree") }}
                </option>
              </select>
            </div>
          </fieldset>
          <fieldset class="row form-group" v-if="add.alignment !== 'yes'">
            <label class="col-6 control-label text-end"
              >{{ $t("Menu.list.grooves.form.posX") }} mm</label
            >
            <div class="col-6">
              <div class="input-group">
                <input
                  @keyup.enter="addGroove"
                  type="number"
                  value="0"
                  v-model="add.pos"
                  step="0.1"
                  min="-10"
                  max="10"
                  class="form-control"
                />
              </div>
              <span class="exact-position-help">
                {{ $t("Menu.list.grooves.form.posYHelp") }}
              </span>
            </div>
          </fieldset>
        </div>
      </div>
      <div class="row">
        <div class="col-6 offset-6">
          <button class="btn btn-block btn-secondary" @click="addGroove()">
            {{ $t("Menu.list.grooves.form.button.add") }}
          </button>
        </div>
      </div>
    </div>
    <div class="row" v-if="getItemnumber">
      <div id="GroovePlan" class="col-12 text-center">
        <div class="groove-box">
          <div id="GrooveParts" :style="{ height: getGroovePartHeight() }">
            <template v-if="possibleItems.list">
              <template v-for="(groove, numericKey) in possibleItems.list">
                <div
                  v-bind:key="'groove' + numericKey"
                  class="groove"
                  :style="{
                    left: groove.px_start + 'px',
                    top: getGrooveTop(numericKey),
                    height: getGrooveHeight(numericKey),
                  }"
                >
                  <span
                    v-bind:title="getGrooveTypeText(groove.type, true)"
                    class="groove-text"
                    @click="toggleGrooveForm(numericKey)"
                  >
                    #{{ numericKey + 1 }}
                    {{ getGrooveTypeText(groove.type, false) }}
                  </span>
                  <span
                    type="button"
                    class="close"
                    aria-label="Close"
                    @click="
                      currentGrooveId = numericKey;
                      dropGroove();
                    "
                  >
                    <img
                      :src="appUrl + '/img/icons/close.svg'"
                      class="icon"
                      alt="close"
                    />
                  </span>
                </div>
              </template>
            </template>
          </div>
        </div>
        <div class="profile-plan-box">
          <img
            class="profile-plan"
            :src="getApiHost + '/v2/images/profile/' + getItemnumber + '.jpg'"
            alt=""
            width="100%"
          />
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import Config from "@/vuex/Config";
import SetData from "@/vuex/SetData";

export default {
  name: "VariationsGrooves",
  props: ["possibleItems", "currentItem"],
  data() {
    return {
      appUrl: Config.getters.getAppUrl,
      getApiHost: Config.getters.getApiHost,
      itemData: SetData.getters.getCurrentItem,
      currentGroove: null,
      currentGrooveId: null,
      add: {
        groove: null,
        width: null,
        object: "R",
        arrangement: "A",
        alignment: "no",
        pos: 0,
        degree: 0,
      },
    };
  },
  updated() {
    if (this.add.groove === null) {
      let firstKey = Object.keys(this.possibleItems.grooves.types)[0];
      this.add.groove = this.possibleItems.grooves.types[firstKey].id;

      this.toggleGrooveForm("add");
    }
  },
  watch: {
    "add.groove": function () {
      if (
        typeof this.possibleItems.grooves.widths[this.add.groove][
          this.add.width
        ] == "undefined"
      ) {
        for (let firstWidth in this.possibleItems.grooves.widths[
          this.add.groove
        ]) {
          this.add.width = firstWidth;
          break;
        }
      }
    },
    "currentGroove.type": function () {
      if (
        typeof this.possibleItems.grooves.widths[this.currentGroove.type][
          this.currentGroove.width
        ] == "undefined"
      ) {
        for (let firstWidth in this.possibleItems.grooves.widths[
          this.currentGroove.type
        ]) {
          this.currentGroove.width = firstWidth;
          break;
        }
      }
    },
  },
  methods: {
    addGroove: function () {
      if (this.add.object.substr(0, 1) != "D") {
        this.add.alignment = "no";
      }

      if (this.add.alignment == "yes") {
        this.add.arrangement = "A";
        this.add.pos = 0;
      }

      let varValue =
        "12_" +
        this.add.width +
        "_" +
        this.add.alignment +
        "_" +
        this.add.pos +
        "_" +
        this.add.groove +
        "_" +
        this.add.object +
        "_" +
        this.add.arrangement +
        "_" +
        this.add.degree;

      this.changeItemByVarValue(varValue);

      this.currentGrooveId = null;
    },
    saveGroove: function () {
      let varValue =
        "13_" +
        this.currentGrooveId +
        "_" +
        this.currentGroove.width +
        "_" +
        this.currentGroove.alignment +
        "_" +
        this.currentGroove.pos_x.replace(".", ",") +
        "_" +
        this.currentGroove.type +
        "_" +
        this.currentGroove.object +
        "_" +
        this.currentGroove.arrangement +
        "_" +
        this.currentGroove.degree;

      this.changeItemByVarValue(varValue);
    },
    dropGroove: function () {
      let varValue = "11_" + this.currentGrooveId;
      this.changeItemByVarValue(varValue);
      this.currentGrooveId = null;
    },
    toggleGrooveForm: function (formId) {
      if (formId !== "add" && formId !== null) {
        this.currentGroove = JSON.parse(
          JSON.stringify(this.possibleItems.list[formId])
        );
      }
      this.currentGrooveId = this.currentGrooveId == formId ? null : formId;
    },
    changeItemByVarValue: function (varValue) {
      this.$parent.$parent.changeItemByVarValue(varValue);
      this.toggleGrooveForm(this.currentGrooveId);
    },
    getGrooveTypeText: function (typeId, fullText) {
      let grooveText = "";
      if (this.possibleItems.grooves && this.possibleItems.grooves.types) {
        for (let numericKey in this.possibleItems.grooves.types) {
          if (this.possibleItems.grooves.types[numericKey].id == typeId) {
            grooveText = this.possibleItems.grooves.types[numericKey].text;
            if (fullText !== true) {
              grooveText = grooveText.substr(0, 15);
              if (
                this.possibleItems.grooves.types[numericKey].text.length > 15
              ) {
                grooveText += " ...";
              }
            }
          }
        }
      }
      return grooveText;
    },
    getGrooveTop: function (numericKey) {
      let grooveTopStep = 0;
      if (numericKey > 0) {
        if (grooveTopStep == 0) {
          grooveTopStep = 3;
        }
        grooveTopStep *= numericKey;
      }
      return grooveTopStep + "rem";
    },
    getGrooveHeight: function (numericKey) {
      let grooveHeight = parseInt(
        this.getGroovePartHeight().replace("rem", "")
      );
      if (numericKey > 0) {
        grooveHeight -= numericKey * 3;
      }
      return grooveHeight + "rem";
    },
    getGroovePartHeight: function () {
      let height = 3;
      if (this.possibleItems.list.length > 0) {
        height *= this.possibleItems.list.length;
      }
      return height + "rem";
    },
  },
  computed: {
    getItemnumber: function () {
      if (typeof this.currentItem == "object") {
        return this.currentItem.itemnumber;
      } else {
        return false;
      }
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
#app {
  label {
    font-weight: normal;
    line-height: 2.2em;
    padding: 0;
  }

  input,
  select {
    font-weight: bold;
  }

  .profile-plan {
    max-width: 30rem;
    max-height: 23rem;
    text-align: center;
    display: inline;
  }

  #GroovePlan {
    position: relative;
    margin-top: 4rem;
    margin-bottom: 4rem;
  }

  .exact-position-help {
    display: inline-block;
    margin: 0.5rem 0 1rem 0;
  }

  #GrooveParts {
    position: relative;
    margin: auto;
    width: 30rem;

    .groove-box,
    .profile-plan-box {
      display: block;
      text-align: center;
    }
  }

  .groove {
    position: absolute;
    border-left: 1px solid #acacac;
    text-align: left;
    width: max-content;

    .groove-text {
      border-bottom: 1px solid #acacac;
    }

    span {
      display: inline-block;
      margin-bottom: -1.5rem;
      margin-left: 0.5rem;
      cursor: pointer;
    }

    span.close {
      img {
        width: 1em;
        margin-bottom: 1.2rem;
      }
    }
  }
}
</style>
